import React from 'react';
import { Colors, Fonts } from '../../../shared/theme';
import commonStyle from '../../../shared/theme/common-style';

export default {
  formWrapper: {
    backgroundColor: Colors.white,
    display: 'flex',
    padding: 20,
  } as React.CSSProperties,
  defaultContent: {
    backgroundColor: Colors.white,
    padding: 20
  } as React.CSSProperties,
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: '56px'
  } as React.CSSProperties,
  textDesc: {
    display: 'flex',
    paddingTop: '20px',
  },
  text14RegularPurple: {
    fontFamily: Fonts.type.KanitRegular,
    fontSize: Fonts.size.text14,
    color: Colors.lightPurple,
    paddingBottom: '20px',
  },
  formDateTextRegular14Gray: {
    fontFamily: Fonts.type.KanitRegular,
    fontSize: Fonts.size.text14,
    color: Colors.font.primary.darkGray
  },
  remarkTextRegular14Gray: {
    fontFamily: Fonts.type.KanitRegular,
    fontSize: Fonts.size.text12,
    color: Colors.font.primary.darkGray,
    paddingTop: '20px'
  },
  formCalendar: {
    paddingTop: '4px',
  },
  calendarInput: {
    width: '250px',
    height: '40px',
    borderRadius: '4px'
  },
  paddingTop20: {
    paddingTop: '20px',
  },
  tooltipText: {
    width: '276px',
    height: '126px',
    fontFamily: Fonts.type.KanitRegular,
    fontSize: Fonts.size.text14,
    color: Colors.white
  },
  buttonAdd: {
    color: Colors.lightPurple,
    borderColor: Colors.lightPurple,
    borderRadius: '4px',
    background: 'transparent',
    fontSize: '16px',
    fontFamily: Fonts.type.KanitRegular,
    height: '40px',
    width: '203px',
  },
  pickReportButton: {
    color: Colors.lightPurple,
    borderColor: Colors.lightPurple,
    borderRadius: '4px',
    background: 'transparent',
    fontSize: '16px',
    fontFamily: Fonts.type.KanitRegular,
    height: '40px',
    width: '161px',
  },
  selectedMenuItem: {
    backgroundColor: '#FCF4FA'
  },
  textNextLine: {
    whiteSpace: 'pre-line',
  },
  tooltipTextNextLine: {
    width: '276px',
    height: '150px',
    fontFamily: Fonts.type.KanitRegular,
    fontSize: Fonts.size.text14,
    color: Colors.white,
    whiteSpace: 'pre-wrap',
  },
  inputContainer: {
    display: 'flex',
    flexDirection: 'row'
  },
  serachButtonContainer: {
    alignSelf: 'end'
  },
  searchButton: {
    ...Fonts.style.textHeaderKanitRegular16,
    background: 'linear-gradient(230.89deg, #7F50B2 0%, #CF1E91 100%',
    color: Colors.white,
    borderColor: Colors.lightPurple,
    height: '40px',
    width: '160px',
    borderRadius: 5
  },
  formItemDate: {
    marginBottom: 0,
    marginTop: '4px'
  },
  formItemBranch: {
    marginBottom: 0,
    marginTop: '4px',
    width: '478px'
  },
  paginationText: {
    fontFamily: Fonts.type.KanitRegular,
    fontSize: Fonts.size.text12,
    color: Colors.font.primary.darkGray,
    ...commonStyle.marginRightSmall
  }
};
